import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlAutoUpscaleService {
  private readonly MAX_ITEMS = 5000;
  private items: Map<string, { width: number; height: number; quality: number }[]> = new Map();

  private set(uuid: string, width: number, height: number, quality: number) {
    const current = this.items.get(uuid) || [];
    this.items.set(uuid, [...current, { width, height, quality }]);
    if (this.items.size > this.MAX_ITEMS) this.items.delete(this.items.keys()[0]);
  }

  public get(uuid: string, width: number, height?: number, quality?: number) {
    const item = this.find(uuid, width, quality);
    if (item) return item;
    this.set(uuid, width, height, quality);
    return { width, height, quality };
  }

  private find(uuid: string, width: number, quality: number) {
    const items = this.items.get(uuid);
    if (!items) return;
    return items.find(item => {
      if (!item.quality && quality) return false;
      if (quality && quality > item.quality) return false;
      if (width > item.width) return false;
      if (width * 8 < item.width) return false;
      return true;
    });
  }
}
